import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { tipoRelatorioOptions } from './constants'

interface Schema {
   id: 'ufDetran' | 'tipoRelatorio' | 'referencia'
}

interface FormDetranManagementReportInterface {
   input?: InputBuildProps & Schema
   select?: SelectBuildProps & Schema
   layout: any
}

export const FormDetranManagementReportValue =
   (): FormDetranManagementReportInterface[] => [
      {
         select: {
            id: 'ufDetran',
            label: 'UF Detran',
            options: [{ text: 'ES', value: 'ES' }],
            defaultValue: 'ES',
            isDisable: true
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      },
      {
         select: {
            id: 'tipoRelatorio',
            label: 'Tipo de Relatório',
            options: tipoRelatorioOptions
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
         }
      },
      {
         input: {
            id: 'referencia',
            label: 'Referência',
            placeholder: 'MM/AAAA',
            maxLength: 7
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      }
   ]